/* eslint-disable @typescript-eslint/no-explicit-any */
// eslint-disable-next-line import/named
import { Component, Input, OnInit } from '@angular/core';
import { catchError, EMPTY, Subscription, tap } from 'rxjs';
import { ChatMessage, GenesysChatService } from '@core/services/genesys-chat/genesys-chat.service';
import { ApplicationUtilitiesService } from '@core/services/api/http/applicationUtilitites.service';
import { environment } from '@environments/environment';
import { GenesysChatConfig } from '@core/models';
import { TranslateService } from '@ngx-translate/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
interface DisplayChatMessage extends ChatMessage {
  safeHtml?: SafeHtml;
}

@Component({
  selector: 'qb-ita-genesys-chat',
  templateUrl: './genesys-chat.component.html',
  styleUrls: ['./genesys-chat.component.scss'],
  standalone: false,
})
export class GenesysChatComponent implements OnInit {
  @Input() visibleInd: boolean;
  @Input() chatConfig: GenesysChatConfig;
  @Input() mocked: boolean;
  componentReady: boolean;
  subscriptions: Subscription[] = [];

  isChatOpen = false;
  isChatWindowOpen = false;
  chatStartTime = '';
  inputName: string = '';
  userName: string = '';

  static component_name = 'GenesysChatComponent';
  static configInputs: string[] = ['visibleInd', 'chatType', 'agentIcon'];

  messageInput = '';
  displayedMessages: DisplayChatMessage[] = [];

  chatVisibility: boolean = false;

  isChatReady: boolean = false;
  isChatStarted: boolean = false;
  isAgentTyping: boolean = false;
  isLoading: boolean = false;

  toggleChat: boolean = true;

  notAvailable: boolean = false;

  constructor(
    private readonly genesysChatService: GenesysChatService,
    private readonly applicationUtilitiesService: ApplicationUtilitiesService,
    private readonly translateService: TranslateService,
    private readonly sanitizer: DomSanitizer
  ) {}

  ngOnInit(): void {
    if (this.mocked) {
      this.chatVisibility = false;
    } else {
      if (window.isChatOpened) {
        this.isChatWindowOpen = true;
      }
      this.applicationUtilitiesService
        .getChatVisibility({ customerType: 'portal', requestType: 'complete' })
        .pipe(
          tap(async response => {
            switch (response.chatVisibilityStatus) {
              case 'NOT_AVAILABLE':
                let not_available_label = this.translateService
                  .get('GENESYS_CHAT.CHATVISIBILITY.NOT_AVAILABLE')
                  .toPromise();
                this.genesysChatService.pushNotAvailableMessage(await not_available_label);
                this.notAvailable = true;
                break;
              case 'AGENTS_NOT_AVAILABLE':
                let no_agents_available_label = this.translateService
                  .get('GENESYS_CHAT.CHATVISIBILITY.NO_AGENTS_AVAILABLE')
                  .toPromise();
                this.genesysChatService.pushNotAvailableMessage(await no_agents_available_label);
                this.notAvailable = true;
                this.isLoading = false;
                break;
              case 'AGENTS_AVAILABLE':
                this.chatVisibility = true;
                break;
            }
          })
        )
        .subscribe();
    }

    this.subscriptions.push(
      this.genesysChatService.readyFLG$.subscribe(isReady => {
        this.isChatReady = isReady;
        if (!environment.production) {
          console.log('Chat is ready in component:', this.isChatReady);
        }
      }),
      this.genesysChatService.startedFLG$.subscribe(isStarted => {
        this.isChatStarted = isStarted;
        if (!environment.production) {
          console.log('Chat has started in component:', isStarted);
        }
      }),
      this.genesysChatService.messages$.subscribe(msgs => {
        this.displayedMessages = this.processMessages(msgs);
        if (msgs && msgs.length > 0 && this.isLoading) {
          this.isLoading = false;
        }
      }),
      this.genesysChatService.isTyping$.subscribe(isTyping => {
        this.isAgentTyping = isTyping;
        if (!environment.production) {
          console.log('Chat has started in component:', isTyping);
        }
      }),
      this.genesysChatService.isLoading$.subscribe(loading => {
        this.isLoading = loading;
      })
    );
  }

  private processMessages(msgs: ChatMessage[]): DisplayChatMessage[] {
    return msgs.map(m => {
      const isHtmlMessage = m.type === 'system' && m.text.includes('<a ');

      if (isHtmlMessage) {
        return {
          ...m,
          safeHtml: this.sanitizer.bypassSecurityTrustHtml(m.text),
        } as DisplayChatMessage;
      }
      return m as DisplayChatMessage;
    });
  }

  submitName(): void {
    this.userName = this.inputName;
    this.isLoading = true;
    this.genesysChatService.loadGenesysChat(this.chatConfig);
    this.genesysChatService.setGenesysChatConfig(this.chatConfig, this.inputName);
  }

  openCustomChatWindow(): void {
    if (this.isChatStarted) {
      window.isChatOpened = true;
      this.isChatWindowOpen = true;
    }
    this.isChatOpen = true;
    const now = new Date();
    this.chatStartTime = now.toLocaleTimeString('es-ES', { hour: '2-digit', minute: '2-digit' });
  }

  closeCustomChatWindow(): void {
    this.isChatOpen = false;
    window.isChatOpened = false;
    this.isChatWindowOpen = false;
  }

  sendUserMessage(): void {
    if (this.messageInput.trim()) {
      this.genesysChatService.sendMessage(this.messageInput);

      this.genesysChatService.pushUserMessage(this.messageInput);

      this.messageInput = '';
    }
  }
  minimize(): void {
    this.toggleChat = !this.toggleChat;
  }
}
export interface GenesysParams {
  visibleInd: boolean;
  mocked: boolean;
  chatType: ChatType;
}

type ChatType = 'general' | 'claim';
